let countrycode = [
    { name: '中国', en: 'China', value: '+86' },
    { name: '中国香港', en: 'Hong Kong (SAR)', value: '+852' },
    { name: '中国澳门', en: 'Macao', value: '+853' },
    { name: '中国台湾', en: 'Taiwan', value: '+886' },
    { name: '美国', en: 'United States', value: '+1' },
    { name: '新加坡', en: 'Singapore', value: '+65' },
    { name: '马来西亚', en: 'Malaysia', value: '+60' },
    { name: '柬埔寨', en: 'Cambodia', value: '+855' },
    { name: '菲律宾', en: 'Philippines', value: '+63' },
    { name: '缅甸', en: 'Burma', value: '+95' },
    { name: '越南', en: 'Vietnam', value: '+84' },
    { name: '日本', en: 'Japan', value: '+81' },
    { name: '老挝', en: 'Laos', value: '+856' },
    { name: '澳大利亚', en: 'Australia', value: '+61' },
    { name: '德国', en: 'Germany', value: '+49' },
    { name: '法国', en: 'France', value: '+33' },
    { name: '加拿大', en: 'Canada', value: '+1' },
    { name: '阿富汗', en: 'Afghanistan', value: '+93' },
    { name: '阿尔巴尼亚', en: 'Albania', value: '+355' },
    { name: '阿尔及利亚', en: 'Algeria', value: '+213' },
    { name: '美属萨摩亚', en: 'American Samoa', value: '+684' },
    { name: '安道尔', en: 'Andorra', value: '+376' },
    { name: '安哥拉', en: 'Angola', value: '+244' },
    { name: '安圭拉', en: 'Anguilla', value: '+1264' },
    { name: '南极洲', en: 'Antarctica', value: '+672' },
    { name: '安提瓜和巴布达', en: 'Antigua and Barbuda', value: '+1268' },
    { name: '阿根廷', en: 'Argentina', value: '+54' },
    { name: '亚美尼亚', en: 'Armenia', value: '+374' },
    { name: '阿鲁巴', en: 'Aruba', value: '+297' },
    { name: '奥地利', en: 'Austria', value: '+43' },
    { name: '阿塞拜疆', en: 'Azerbaijan', value: '+994' },
    { name: '巴林', en: 'Bahrain', value: '+973' },
    { name: '孟加拉国', en: 'Bangladesh', value: '+880' },
    { name: '巴巴多斯', en: 'Barbados', value: '+1246' },
    { name: '白俄罗斯', en: 'Belarus', value: '+375' },
    { name: '比利时', en: 'Belgium', value: '+32' },
    { name: '伯利兹', en: 'Belize', value: '+501' },
    { name: '贝宁', en: 'Benin', value: '+229' },
    { name: '百慕大', en: 'Bermuda', value: '+1441' },
    { name: '不丹', en: 'Bhutan', value: '+975' },
    { name: '玻利维亚', en: 'Bolivia', value: '+591' },
    { name: '波黑', en: 'Bosnia and Herzegovina', value: '+387' },
    { name: '博茨瓦纳', en: 'Botswana', value: '+267' },
    { name: '巴西', en: 'Brazil', value: '+55' },
    { name: '英属维尔京群岛', en: 'British Virgin Islands', value: '+1284' },
    { name: '文莱', en: 'Brunei Darussalam', value: '+673' },
    { name: '保加利亚', en: 'Bulgaria', value: '+359' },
    { name: '布基纳法索', en: 'Burkina Faso', value: '+226' },
    { name: '布隆迪', en: 'Burundi', value: '+257' },
    { name: '喀麦隆', en: 'Cameroon', value: '+237' },
    { name: '佛得角', en: 'Cape Verde', value: '+238' },
    { name: '开曼群岛', en: 'Cayman Islands', value: '+1345' },
    { name: '中非', en: 'Central African Republic', value: '+236' },
    { name: '乍得', en: 'Chad', value: '+235' },
    { name: '智利', en: 'Chile', value: '+56' },
    { name: '圣诞岛', en: 'Christmas Island', value: '+61' },
    { name: '科科斯（基林）群岛', en: 'Cocos (Keeling) Islands', value: '+61' },
    { name: '哥伦比亚', en: 'Colombia', value: '+57' },
    { name: '科摩罗', en: 'Comoros', value: '+269' },
    { name: '刚果（金）', en: 'Democratic Republic of the Congo', value: '+243' },
    { name: '刚果（布）', en: 'Republic of the Congo', value: '+242' },
    { name: '库克群岛', en: 'Cook Islands', value: '+682' },
    { name: '哥斯达黎加', en: 'Costa Rica', value: '+506' },
    { name: '科特迪瓦', en: "Cote d'Ivoire", value: '+225' },
    { name: '克罗地亚', en: 'Croatia', value: '+385' },
    { name: '古巴', en: 'Cuba', value: '+53' },
    { name: '塞浦路斯', en: 'Cyprus', value: '+357' },
    { name: '捷克', en: 'Czech Republic', value: '+420' },
    { name: '丹麦', en: 'Denmark', value: '+45' },
    { name: '吉布提', en: 'Djibouti', value: '+253' },
    { name: '多米尼克', en: 'Dominica', value: '+1767' },
    { name: '多米尼加', en: 'Dominican Republic', value: '+1809' },
    { name: '厄瓜多尔', en: 'Ecuador', value: '+593' },
    { name: '埃及', en: 'Egypt', value: '+20' },
    { name: '萨尔瓦多', en: 'El Salvador', value: '+503' },
    { name: '赤道几内亚', en: 'Equatorial Guinea', value: '+240' },
    { name: '厄立特里亚', en: 'Eritrea', value: '+291' },
    { name: '爱沙尼亚', en: 'Estonia', value: '+372' },
    { name: '埃塞俄比亚', en: 'Ethiopia', value: '+251' },
    { name: '福克兰群岛（马尔维纳斯）', en: 'Falkland Islands (Islas Malvinas)', value: '+500' },
    { name: '法罗群岛', en: 'Faroe Islands', value: '+298' },
    { name: '斐济', en: 'Fiji', value: '+679' },
    { name: '芬兰', en: 'Finland', value: '+358' },
    { name: '法属圭亚那', en: 'French Guiana', value: '+594' },
    { name: '法属波利尼西亚', en: 'French Polynesia', value: '+689' },
    { name: '加蓬', en: 'Gabon', value: '+241' },
    { name: '格鲁吉亚', en: 'Georgia', value: '+995' },
    { name: '加纳', en: 'Ghana', value: '+233' },
    { name: '直布罗陀', en: 'Gibraltar', value: '+350' },
    { name: '希腊', en: 'Greece', value: '+30' },
    { name: '格陵兰', en: 'Greenland', value: '+299' },
    { name: '格林纳达', en: 'Grenada', value: '+1473' },
    { name: '瓜德罗普', en: 'Guadeloupe', value: '+590' },
    { name: '关岛', en: 'Guam', value: '+1671' },
    { name: '危地马拉', en: 'Guatemala', value: '+502' },
    { name: '根西岛', en: 'Guernsey', value: '+1481' },
    { name: '几内亚', en: 'Guinea', value: '+224' },
    { name: '几内亚比绍', en: 'Guinea-Bissau', value: '+245' },
    { name: '圭亚那', en: 'Guyana', value: '+592' },
    { name: '海地', en: 'Haiti', value: '+509' },
    { name: '梵蒂冈', en: 'Holy See (Vatican City)', value: '+379' },
    { name: '洪都拉斯', en: 'Honduras', value: '+504' },
    { name: '匈牙利', en: 'Hungary', value: '+36' },
    { name: '冰岛', en: 'Iceland', value: '+354' },
    { name: '印度', en: 'India', value: '+91' },
    { name: '印度尼西亚', en: 'Indonesia', value: '+62' },
    { name: '伊朗', en: 'Iran', value: '+98' },
    { name: '伊拉克', en: 'Iraq', value: '+964' },
    { name: '爱尔兰', en: 'Ireland', value: '+353' },
    { name: '以色列', en: 'Israel', value: '+972' },
    { name: '意大利', en: 'Italy', value: '+39' },
    { name: '牙买加', en: 'Jamaica', value: '+1876' },
    { name: '约旦', en: 'Jordan', value: '+962' },
    { name: '哈萨克斯坦', en: 'Kazakhstan', value: '+73' },
    { name: '肯尼亚', en: 'Kenya', value: '+254' },
    { name: '基里巴斯', en: 'Kiribati', value: '+686' },
    { name: '朝鲜', en: 'North Korea', value: '+850' },
    { name: '韩国', en: 'South Korea', value: '+82' },
    { name: '科威特', en: 'Kuwait', value: '+965' },
    { name: '吉尔吉斯斯坦', en: 'Kyrgyzstan', value: '+996' },
    { name: '拉脱维亚', en: 'Latvia', value: '+371' },
    { name: '黎巴嫩', en: 'Lebanon', value: '+961' },
    { name: '莱索托', en: 'Lesotho', value: '+266' },
    { name: '利比里亚', en: 'Liberia', value: '+231' },
    { name: '利比亚', en: 'Libya', value: '+218' },
    { name: '列支敦士登', en: 'Liechtenstein', value: '+423' },
    { name: '立陶宛', en: 'Lithuania', value: '+370' },
    { name: '卢森堡', en: 'Luxembourg', value: '+352' },
    { name: '前南马其顿', en: 'The Former Yugoslav Republic of Macedonia', value: '+389' },
    { name: '马达加斯加', en: 'Madagascar', value: '+261' },
    { name: '马拉维', en: 'Malawi', value: '+265' },
    { name: '马尔代夫', en: 'Maldives', value: '+960' },
    { name: '马里', en: 'Mali', value: '+223' },
    { name: '马耳他', en: 'Malta', value: '+356' },
    { name: '马绍尔群岛', en: 'Marshall Islands', value: '+692' },
    { name: '马提尼克', en: 'Martinique', value: '+596' },
    { name: '毛里塔尼亚', en: 'Mauritania', value: '+222' },
    { name: '毛里求斯', en: 'Mauritius', value: '+230' },
    { name: '马约特', en: 'Mayotte', value: '+269' },
    { name: '墨西哥', en: 'Mexico', value: '+52' },
    { name: '密克罗尼西亚', en: 'Federated States of Micronesia', value: '+691' },
    { name: '摩尔多瓦', en: 'Moldova', value: '+373' },
    { name: '摩纳哥', en: 'Monaco', value: '+377' },
    { name: '蒙古', en: 'Mongolia', value: '+976' },
    { name: '蒙特塞拉特', en: 'Montserrat', value: '+1664' },
    { name: '摩洛哥', en: 'Morocco', value: '+212' },
    { name: '莫桑比克', en: 'Mozambique', value: '+258' },
    { name: '纳米尼亚', en: 'Namibia', value: '+264' },
    { name: '瑙鲁', en: 'Nauru', value: '+674' },
    { name: '尼泊尔', en: 'Nepal', value: '+977' },
    { name: '荷兰', en: 'Netherlands', value: '+31' },
    { name: '荷属安的列斯', en: 'Netherlands Antilles', value: '+599' },
    { name: '新喀里多尼亚', en: 'New Caledonia', value: '+687' },
    { name: '新西兰', en: 'New Zealand', value: '+64' },
    { name: '尼加拉瓜', en: 'Nicaragua', value: '+505' },
    { name: '尼日尔', en: 'Niger', value: '+227' },
    { name: '尼日利亚', en: 'Nigeria', value: '+234' },
    { name: '纽埃', en: 'Niue', value: '+683' },
    { name: '诺福克岛', en: 'Norfolk Island', value: '+6723' },
    { name: '北马里亚纳', en: 'Northern Mariana Islands', value: '+1' },
    { name: '挪威', en: 'Norway', value: '+47' },
    { name: '阿曼', en: 'Oman', value: '+968' },
    { name: '巴基斯坦', en: 'Pakistan', value: '+92' },
    { name: '帕劳', en: 'Palau', value: '+680' },
    { name: '巴拿马', en: 'Panama', value: '+507' },
    { name: '巴布亚新几内亚', en: 'Papua New Guinea', value: '+675' },
    { name: '巴拉圭', en: 'Paraguay', value: '+595' },
    { name: '秘鲁', en: 'Peru', value: '+51' },
    { name: '波兰', en: 'Poland', value: '+48' },
    { name: '葡萄牙', en: 'Portugal', value: '+351' },
    { name: '波多黎各', en: 'Puerto Rico', value: '+1809' },
    { name: '卡塔尔', en: 'Qatar', value: '+974' },
    { name: '留尼汪', en: 'Reunion', value: '+262' },
    { name: '罗马尼亚', en: 'Romania', value: '+40' },
    { name: '俄罗斯', en: 'Russia', value: '+7' },
    { name: '卢旺达', en: 'Rwanda', value: '+250' },
    { name: '圣赫勒拿', en: 'Saint Helena', value: '+290' },
    { name: '圣基茨和尼维斯', en: 'Saint Kitts and Nevis', value: '+1869' },
    { name: '圣卢西亚', en: 'Saint Lucia', value: '+1758' },
    { name: '圣皮埃尔和密克隆', en: 'Saint Pierre and Miquelon', value: '+508' },
    { name: '圣文森特和格林纳丁斯', en: 'Saint Vincent and the Grenadines', value: '+1784' },
    { name: '萨摩亚', en: 'Samoa', value: '+685' },
    { name: '圣马力诺', en: 'San Marino', value: '+378' },
    { name: '圣多美和普林西比', en: 'Sao Tome and Principe', value: '+239' },
    { name: '沙特阿拉伯', en: 'Saudi Arabia', value: '+966' },
    { name: '塞内加尔', en: 'Senegal', value: '+221' },
    { name: '塞尔维亚和黑山', en: 'Serbia and Montenegro', value: '+381' },
    { name: '塞舌尔', en: 'Seychelles', value: '+248' },
    { name: '塞拉利', en: 'Sierra Leone', value: '+232' },
    { name: '斯洛伐克', en: 'Slovakia', value: '+421' },
    { name: '斯洛文尼亚', en: 'Slovenia', value: '+386' },
    { name: '所罗门群岛', en: 'Solomon Islands', value: '+677' },
    { name: '索马里', en: 'Somalia', value: '+252' },
    { name: '南非', en: 'South Africa', value: '+27' },
    { name: '西班牙', en: 'Spain', value: '+34' },
    { name: '斯里兰卡', en: 'Sri Lanka', value: '+94' },
    { name: '苏丹', en: 'Sudan', value: '+249' },
    { name: '苏里南', en: 'Suriname', value: '+597' },
    { name: '斯瓦尔巴岛和扬马延岛', en: 'Svalbard', value: '+47' },
    { name: '斯威士兰', en: 'Swaziland', value: '+268' },
    { name: '瑞典', en: 'Sweden', value: '+46' },
    { name: '瑞士', en: 'Switzerland', value: '+41' },
    { name: '叙利亚', en: 'Syria', value: '+963' },
    { name: '塔吉克斯坦', en: 'Tajikistan', value: '+992' },
    { name: '坦桑尼亚', en: 'Tanzania', value: '+255' },
    { name: '泰国', en: 'Thailand', value: '+66' },
    { name: '巴哈马', en: 'The Bahamas', value: '+1242' },
    { name: '冈比亚', en: 'The Gambia', value: '+220' },
    { name: '多哥', en: 'Togo', value: '+228' },
    { name: '托克劳', en: 'Tokelau', value: '+690' },
    { name: '汤加', en: 'Tonga', value: '+676' },
    { name: '特立尼达和多巴哥', en: 'Trinidad and Tobago', value: '+1868' },
    { name: '突尼斯', en: 'Tunisia', value: '+216' },
    { name: '土耳其', en: 'Turkey', value: '+90' },
    { name: '土库曼斯坦', en: 'Turkmenistan', value: '+993' },
    { name: '特克斯和凯科斯群岛', en: 'Turks and Caicos Islands', value: '+1649' },
    { name: '图瓦卢', en: 'Tuvalu', value: '+688' },
    { name: '乌干达', en: 'Uganda', value: '+256' },
    { name: '乌克兰', en: 'Ukraine', value: '+380' },
    { name: '阿拉伯联合酋长国', en: 'United Arab Emirates', value: '+971' },
    { name: '英国', en: 'United Kingdom', value: '+44' },
    { name: '乌拉圭', en: 'Uruguay', value: '+598' },
    { name: '乌兹别克斯坦', en: 'Uzbekistan', value: '+998' },
    { name: '瓦努阿图', en: 'Vanuatu', value: '+678' },
    { name: '委内瑞拉', en: 'Venezuela', value: '+58' },
    { name: '美属维尔京群岛', en: 'Virgin Islands', value: '+1340' },
    { name: '瓦利斯和富图纳', en: 'Wallis and Futuna', value: '+681' },
    { name: '也门', en: 'Yemen', value: '+967' },
    { name: '赞比亚', en: 'Zambia', value: '+260' },
    { name: '津巴布韦', en: 'Zimbabwe', value: '+263' }
]

export default countrycode
